<template>
  <div :class="$style.flexContainer">
    <p
      :class="$style.userState"
      :data-test-id="$testId('state')"
      :title="state"
    >
      {{ state }}
    </p>
    <div
      v-if="tooltipText"
      :class="[$style.flexContainer, $style.tooltipWrapper]"
      :data-test-id="$testId('eventBadge')"
    >
      <TooltipIcon
        ariaLabel="User Status scheduled for update"
        :class="$style.tooltipText"
        icon="calendar"
        isMarkdown
        :text="tooltipText"
      />
    </div>
  </div>
</template>

<script>
import {
  ItemTypeConsts, ModuleConsts, StoreModuleMap,
} from 'client/util/Constants';
import { TooltipIcon } from '@jumpcloud/ui-components';
import { capitalize, uniqBy } from 'lodash';
import {
  dateDisplayFormat,
  userStateActionMap,
  userStateActionType,
} from 'client/systemusers/constants/SystemUserConstants';
import { mapState } from 'vuex';
import DateUtil from 'client/util/DateUtil';

const { activated, staged, suspended } = ModuleConsts.systemUser.accountStates;
const systemUserCollection = StoreModuleMap[ItemTypeConsts.systemUser];

export default {
  name: 'UserState',

  components: {
    TooltipIcon,
  },

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  accountStateMap: new Map([
    [activated, 'Active'],
    [staged, 'Staged'],
    [suspended, 'Suspended'],
  ]),

  dateFormat: dateDisplayFormat,

  computed: {
    ...mapState(systemUserCollection, ['scheduledStateChanges']),

    // Only return one activation and one suspension, for the user
    getScheduledEvents() {
      const events = this.scheduledStateChanges
        .filter(change => change.systemUserId === this.item._id)
        .sort();

      return uniqBy(events, 'state');
    },

    state() {
      return this.$options.accountStateMap.get(this.item.state);
    },

    tooltipText() {
      let text = '';

      const events = this.getScheduledEvents;
      const infoText = 'All scheduled state changes are accessible from the user’s profile page.';

      // Assumes there is at most one activation and one suspension
      if (events.length) {
        events.forEach((event) => {
          const scheduledDate = DateUtil
            .customFormatDate(event.scheduledDate, this.$options.dateFormat);
          const action = event.state === activated
            ? userStateActionType.activate
            : userStateActionType.suspend;
          text += `${capitalize(userStateActionMap.get(action).noun)} scheduled for ${scheduledDate}\n`;
        });
      }

      if (events.length) {
        text = `${text}\n${infoText}`;
      }

      return text;
    },
  },

};
</script>

<style scoped module>
@import '../../../css/flex.css';

@value (jcGrey200, jcGrey800, jcSecondary) from '~css/brand-colors.css';

.flexContainer {
  align-items: center;
}

.tooltipWrapper {
  bottom: 3px;
  position: relative;
}

.tooltipText {
  --tooltip-max-width: 45ch;
}

.userState {
  font-weight: 700;
  margin: 0 2px 0 0;
}

.userState:hover {
  color: jcSecondary;
}
</style>
